import { render, staticRenderFns } from "./bootstrap.vue?vue&type=template&id=442c348a"
import script from "./bootstrap.vue?vue&type=script&lang=js"
export * from "./bootstrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports